import { FormControl } from '@angular/forms';
import { isSameDay, setHours, setMinutes, startOfDay } from 'date-fns';

export function readMomentHourMinute(value: unknown): { hour: number; minute: number } | null {
  const momentLike = value as { hour?: () => number; minute?: () => number };
  if (typeof momentLike.hour === 'function' && typeof momentLike.minute === 'function') {
    return { hour: momentLike.hour(), minute: momentLike.minute() };
  }
  return null;
}

export function applyPendingDateSelection(
  date: Date,
  hoursControl: FormControl<number>,
  minutesControl: FormControl<number>,
  dateControl: FormControl<Date>,
): void {
  const keepTime = isSameDay(date, new Date());
  const hours = keepTime ? hoursControl.value ?? 0 : 0;
  const minutes = keepTime ? minutesControl.value ?? 0 : 0;
  if (!keepTime) {
    hoursControl.setValue(0, { emitEvent: false });
    minutesControl.setValue(0, { emitEvent: false });
  }
  dateControl.setValue(setMinutes(setHours(startOfDay(date), hours), minutes), { emitEvent: false });
}

export function syncDateDisplay(
  dateControl: FormControl<Date>,
  hoursControl: FormControl<number>,
  minutesControl: FormControl<number>,
): void {
  const date = dateControl.value;
  if (!date) {
    return;
  }
  const combined = setMinutes(setHours(startOfDay(date), hoursControl.value ?? 0), minutesControl.value ?? 0);
  dateControl.setValue(combined, { emitEvent: false });
}
